import { Filter, FilterConfig } from 'src/utils/composeFilter.ts';
import { useCallback, useMemo } from 'react';
import { getFilterValuesFromUrl } from 'src/utils/getFilterValuesFromUrl.ts';
import { createCheckboxHandler } from 'src/modules/common/hooks/useFilterLogic/createCheckboxHandler.ts';
import { CheckboxHandler } from 'src/modules/common/types/CheckboxHandler.ts';

export function useFilterLogic(
    filterConfig: FilterConfig,
    searchParams: URLSearchParams,
): [
        Filter,
        CheckboxHandler,
        (detail: { name: string; value: string }) => Filter,
        (config: FilterConfig, search: URLSearchParams) => URLSearchParams,
    ] {
    const filter = useMemo(
        () => getFilterValuesFromUrl(searchParams, filterConfig),
        [searchParams, filterConfig],
    );

    const checkboxHandlerInstance = useMemo(
        () => createCheckboxHandler(filter),
        [filter],
    );

    const checkboxHandler = useCallback(
        (value: { name: string; value: string | string[] }) => checkboxHandlerInstance(value),
        [checkboxHandlerInstance],
    );

    const radioHandler = useCallback((detail: { name: string; value: string }): Filter => ({
        ...filter,
        [detail.name]: [detail.value],
    }), [filter]);

    const resetHandler = (config: FilterConfig, search: URLSearchParams): URLSearchParams => {
        config.forEach((item) => {
            const [name] = item;
            search.delete(name);
        });
        return search;
    };

    return [
        filter,
        checkboxHandler,
        radioHandler,
        resetHandler,
    ];
}
